import type html2canvas from 'html2canvas';

/** Default options aligned with chart/matrix PNG exports in this tool. */
export const DEFAULT_HTML2CANVAS_PNG_OPTIONS = {
  scale: 2,
  useCORS: true,
  foreignObjectRendering: false,
} as const;

/** html2canvas options merged after {@link DEFAULT_HTML2CANVAS_PNG_OPTIONS}. */
export type DownloadDomElementAsPngOptions = Partial<typeof DEFAULT_HTML2CANVAS_PNG_OPTIONS> &
  Partial<NonNullable<Parameters<typeof html2canvas>[1]>>;

/**
 * Captures a DOM node as PNG and triggers a download. Waits two animation frames so
 * layout (e.g. legend toggled visible) can settle before paint.
 */
export async function downloadDomElementAsPng(
  element: HTMLElement,
  filename: string,
  options?: DownloadDomElementAsPngOptions,
): Promise<void> {
  await new Promise<void>((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
  const { default: html2canvas } = await import('html2canvas');
  const canvas = await html2canvas(element, {
    ...DEFAULT_HTML2CANVAS_PNG_OPTIONS,
    ...options,
  });
  const url = canvas.toDataURL('image/png');
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
}
